import { STATIC_HM_PATH } from "@project/shared-types";
import DocSvg from "../../../assets/taiga-uikit/icons/document-download.svg?react";
import EditSvg from "../../../assets/taiga-uikit/icons/edit-2.svg?react";
import UserSvg from "../../../assets/taiga-uikit/icons/profile-2user.svg?react";
import WarningSvg from "../../../assets/taiga-uikit/icons/warning-2.svg?react";
import { Text } from "../../../components/texts/text";
import Title from "../../../components/texts/title";
import { _colorText, _sizeHeading, _sizeText } from "../../../core/core";
import "./BigBlock.css";

export const BigBlock = ({ block, ...props }: { block: any }) => {
  return (
    <div className={"big-block "}>
      <Title type={_sizeHeading.h2}>{block.title}</Title>
      <div className="big-block-body">
        <div className="big-block-t">
          <div className="big-card">
            <Title type={_sizeHeading.h3}>{block.card_title_1}</Title>
            <div className="big-card-info">
              <Text size={_sizeText.m} color={_colorText.black}>
                {block.card_text_1}
              </Text>
              <div className="big-card-lable">
                <EditSvg></EditSvg>
                <Text size={_sizeText.m} color={_colorText.black}>
                  {block.card_small_1}
                </Text>
              </div>
            </div>
          </div>
          <div className="big-card">
            <Title type={_sizeHeading.h3}>{block.card_title_2}</Title>
            <div className="big-card-info">
              <Text size={_sizeText.m} color={_colorText.black}>
                {block.card_text_2}
              </Text>
              <div className="big-card-lable">
                <DocSvg></DocSvg>
                <Text size={_sizeText.m} color={_colorText.black}>
                  {block.card_small_2}
                </Text>
              </div>
            </div>
          </div>
          <div className="big-card">
            <Title type={_sizeHeading.h3} color={_colorText.black}>
              {block.card_title_3}
            </Title>
            <div className="big-card-info">
              <Text size={_sizeText.m} color={_colorText.black}>
                {block.card_text_3}
              </Text>
              <div className="big-card-lable">
                <UserSvg></UserSvg>
                <Text size={_sizeText.m} color={_colorText.black}>
                  {block.card_small_3}
                </Text>
              </div>
            </div>
          </div>
        </div>
        <div className="big-block-b">
          <div className="big-block-l">
            <Title type={_sizeHeading.h3}>{block.card_title_4}</Title>
            <div className="big-card-info">
              <div className="big-card-info-t">
                {block.card_text_4
                  .split("|")
                  .map((text: string, index: number) => (
                    <div key={index} className="big-card-row">
                      <Text size={_sizeText.m} color={_colorText.black}>
                        •
                      </Text>
                      <Text size={_sizeText.m} color={_colorText.black}>
                        {text}
                      </Text>
                    </div>
                  ))}
              </div>
              <div className="big-card-lable">
                <WarningSvg />
                <Text size={_sizeText.m} color={_colorText.black}>
                  {block.card_small_4}
                </Text>
              </div>
            </div>
          </div>
          <div className="iphone-15-center">
            <img
              className="iphone-15-front"
              src={`${STATIC_HM_PATH}/images/bigtext.webp`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
